import React from "react";

export const UtmContext = React.createContext({
    utm:false,
    utmSet: () => {},
    utmLoaded:false,
    utmLoadedSet: () => {}
});